<template>
  <div>
    <div v-if="value.length < maxWord">{{ value }}</div>
    <a-popover v-else trigger="hover">
      <template #content>
        <div style="max-width: 200px; word-break: break-all">{{ value }}</div>
      </template>
      <div class="ellipsis">
        {{ value.slice(0, maxWord) }}
      </div>
    </a-popover>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "Ellipsis",
  props: {
    value: { type: String, default: "" },

    maxWord: { type: Number, default: 100 },
  },
});
</script>

<style lang="less" scoped>
.ellipsis {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
